import React, { useEffect, useState } from "react";
import Channel from "./Channel";
import tableInitWorker from "Utils/restructure.worker";
import WorkerBuilder from "Utils/builder.worker";
import valueExtractorWorker from "Utils/valueExtractor.worker";
import Draggable from "react-draggable";
import { useSelector } from "react-redux";
import { handleDefaultGridDrop, handleDefaultGridDimension } from "./NewPage/DefaultWidgetFunctions"

const tableInitializer = new WorkerBuilder(tableInitWorker);
const valueExtractor = new WorkerBuilder(valueExtractorWorker);

const Channels = ({
  data,
  socketData,
  // handleDefaultGridDrop,
  // handleDefaultGridDimension,
  openNewPage,
  selectedTabIndex,
  tabIndexDefaultGrid,
  tempTabIndexDefaultGrid,
  isMobile,
  scaleValue,
  setDefaultGridPosi,
  tempImages,
  setTempImages,
  setUpdatedImages,
  setDefaultGridDimension,

}) => {
  const [tableData, setTableData] = useState([]); // Data formatted for Table
  const [init, setInit] = useState(false);
  const [isWorkerBusy, setIsWorkerBusy] = useState(false);
  const [dateTimesLive, setDateTimesLive] = useState([]); // DateTime labels for y-axis
  const [dataArrLive, setDataArrLive] = useState([]); // Real-time data received for live
  const [channelNames, setChannelNames] = useState([]); //  Channel names
  const graphData = useSelector(state => state.viewData.graphData)

  useEffect(() => {
    // Parsing data from from get request in the parent component
    const fetchData = async () => {
      try {
        if (Array.isArray(graphData)) {
          const copiedDataset = [...graphData];
          // Live Data Chart
          const currentTime = new Date();
          currentTime.setTime(currentTime.getTime() - 1 * 60 * 60 * 1000); // Subtracting 1 hour
          const liveDataFiltered = copiedDataset.filter(
            (dataset) => new Date(dataset.time) >= currentTime
          );

          // Restructure Data for Table
          const tableDataArrayGen = async () => {
            const dataPromise = new Promise((resolve) => {
              tableInitializer.onmessage = (e) => {
                resolve(e.data);
              };
            });
            tableInitializer.postMessage({ data: liveDataFiltered });
            return await dataPromise;
          };
          const tableDataArray = await tableDataArrayGen();
          let gotHeaders = [];
          if (tableDataArray.data) {
            gotHeaders = tableDataArray.headers;
            const arrayOfValueArrays = tableDataArray.channelWiseData;

            const getNewDataArr = () =>
              gotHeaders.map((header, index) => ({
                label: header,
                data: arrayOfValueArrays[index],
                fill: false,
              }));

            const newDataArr = getNewDataArr();

            setChannelNames(gotHeaders);
            setTableData(tableDataArray.data);
            setDataArrLive(newDataArr);
            setDateTimesLive(tableDataArray.dateTimeArray);
            setInit(true);
          }
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [graphData]);

  useEffect(() => {
    try {
      const updateData = async () => {
        if (socketData && init && !isWorkerBusy) {
          setIsWorkerBusy(true);
          const structuredData = async () => {
            const dataPromise = new Promise((resolve) => {
              valueExtractor.onmessage = (e) => {
                resolve(e.data);
              };
            });
            valueExtractor.postMessage({
              socketData: socketData,
              currentTable: tableData,
              dateTimeArray: dateTimesLive,
              dataArray: dataArrLive,
              headers: channelNames,
              duration: 1,
            });
            return await dataPromise;
          };

          const workerResponse = await structuredData();
          if (workerResponse.updatedTable) {
            setChannelNames(workerResponse.updatedHeaders);
            setTableData(workerResponse.updatedTable);
            setDataArrLive(workerResponse.updatedLiveArray);
            setDateTimesLive(workerResponse.updatedDateTimeArray);
          }
        }
      };
      updateData();
    } catch (error) {
      console.log(error);
    }
    setIsWorkerBusy(false);
  }, [graphData , socketData]);



  const generateDefaultGrid = () => {
    const selectedTabDevices = tabIndexDefaultGrid[selectedTabIndex];
    if (Array.isArray(selectedTabDevices)) {
      return selectedTabDevices?.map((device, index) => {
        const { x, y, id, width, height } = device;

        const deviceStyle = {
          position: "absolute",
          left: x ? x + "px" : "",
          top: y ? y + "px" : "",
          display: isMobile ? "grid" : "flex",
          gridTemplateColumns: "1fr 1fr 1fr",
          flexWrap: "wrap",
          width: width ? width : "max-content",
          maxWidth: isMobile ? "max-content" : "100%",
          height: height ? height : "",
          padding: "1.2rem",
          gap: "2rem",
          maxHeight: "75vh",
          overflowY: "auto",
          resize: openNewPage ? "both" : "",
          scale: isMobile ? scaleValue.toString() : "1",
          zIndex: "1"
        };

        return (
          <>
            {tableData.length > 0 ? (
              <div style={deviceStyle} id="DefaultGrid">
                {tableData.map((channel, index) => (
                  <Channel data={channel} />
                ))}
              </div>

            ) : (
              <div>Live channels are not available</div>
            )}
          </>
        );
      });
    } else {
      const deviceStyle = {
        maxWidth: isMobile ? "max-content" : "100%",
        position: "absolute",
        top: "70px",
        display: isMobile ? "grid" : "flex",
        gridTemplateColumns: "1fr 1fr 1fr",
        flexWrap: "wrap",
        padding: "1.2rem",
        gap: "2rem",
        maxHeight: "75vh",
        overflowY: "auto",
        resize: openNewPage ? "both" : "",
        scale: isMobile ? scaleValue.toString() : "1",
        zIndex: "1"
      };
      return (
        <>
          {tableData.length > 0 ? (
            <div style={deviceStyle} id="DefaultGrid">
              {tableData.map((channel, index) => (
                <Channel data={channel} />
              ))}
            </div>

          ) : (
            <div>Live channels are not available</div>
          )}
        </>
      );
    }
  }

  const tempGenerateDefaultGrid = () => {
    const selectedTabDevices = tempTabIndexDefaultGrid[selectedTabIndex];
    if (Array.isArray(selectedTabDevices)) {
      return selectedTabDevices?.map((device, index) => {
        const { x, y, id, width, height } = device;
        const deviceStyle = {
          position: "absolute",
          left: x ? x + "px" : "",
          top: y ? y + "px" : "",
          display: isMobile ? "grid" : "flex",
          gridTemplateColumns: "1fr 1fr 1fr",
          flexWrap: "wrap",
          width: width ? width : "max-content",
          maxWidth: isMobile ? "max-content" : "100%",
          height: height ? height : "",
          padding: "1.2rem",
          gap: "2rem",
          maxHeight: "75vh",
          overflowY: "auto",
          resize: openNewPage ? "both" : "",
          zIndex: "1",
        };
        return (
          <>
            <Draggable bounds="parent"
              onStop={(e, data) => handleDefaultGridDrop(e, data, {
                setDefaultGridPosi,
                tempTabIndexDefaultGrid,
                tempImages,
                setTempImages,
                setUpdatedImages,
                id,
                x,
                y
              })}
            >
              {tableData.length > 0 ? (
                <div style={deviceStyle} id="DefaultGrid" onContextMenu={(e) => handleDefaultGridDimension(e, {
                  tempImages,
                  setDefaultGridDimension,
                  tabIndexDefaultGrid,
                  setTempImages,
                  setUpdatedImages,
                  id
                })}>
                  {tableData.map((channel, index) => (
                    <Channel data={channel} />
                  ))}
                </div>

              ) : (
                <div>Live channels are not available</div>
              )}
            </Draggable>
          </>
        );
      });
    } else {
      const deviceStyle = {
        maxWidth: isMobile ? "max-content" : "100%",
        position: "absolute",
        top: "70px",
        display: isMobile ? "grid" : "flex",
        gridTemplateColumns: "1fr 1fr 1fr",
        flexWrap: "wrap",
        padding: "1.2rem",
        gap: "2rem",
        maxHeight: "75vh",
        overflowY: "auto",
        resize: openNewPage ? "both" : "",
        zIndex: "1",
      };
      return (
        <>
          <Draggable bounds="parent"
          >
            {tableData.length > 0 ? (
              <div style={deviceStyle} id="DefaultGrid" onContextMenu={(e) => handleDefaultGridDimension(e, {
                tempImages,
                setDefaultGridDimension,
                tabIndexDefaultGrid,
                setTempImages,
                setUpdatedImages
              })}>
                {tableData.map((channel, index) => (
                  <Channel data={channel} />
                ))}
              </div>

            ) : (
              <div>Live channels are not available</div>
            )}
          </Draggable>
        </>
      );
    }
  };

  return (
    <>
      {openNewPage ? (
        tempGenerateDefaultGrid()
      ) : (
        generateDefaultGrid()
      )}
    </>
  )
};

export default Channels;
